//@ts-ignore
import africa from "ui-kit/assets/images/continents/africa.png";
//@ts-ignore
import northAmerica from "ui-kit/assets/images/continents/america.png";
//@ts-ignore
import asia from "ui-kit/assets/images/continents/asia.png";
//@ts-ignore
import europe from "ui-kit/assets/images/continents/europe.png";
//@ts-ignore
import oceania from "ui-kit/assets/images/continents/pacific.png";
//@ts-ignore
import southAmerica from "ui-kit/assets/images/continents/south-america.png";
//@ts-ignore
import nationalContinents from "ui-kit/assets/images/continents/national.png";

export enum Gender {
	MALE = "Male",
	FEMALE = "Female",
}

export enum TeamGender {
	MALE = "Male",
	FEMALE = "Female",
	MIXED = "Mixed",
}

export interface GenderView {
	available: boolean;
}

export interface GendersView {
	male: GenderView;
	female: GenderView;
}

export interface DataSourceOption {
	key: string;
	label: string;
	isSelectable: boolean;
	genders?: GendersView;
	logo?: string | null;
	country?: string | null;
	teamCount?: number;
}

export interface TeamGroupTeam {
	id: number;
	name: string;
	logo: string | null;
	country: string | null;
	gender: TeamGender | null;
}

export interface TeamGroupClub {
	id: number;
	name: string;
	logo: string | null;
	country: string | null;
}

export interface SingleCountryData {
	code: string;
	enabled: boolean;
	tooltip: string | null;
	name: string;
}

export type ContinentData = SingleCountryData[];

export enum Continent {
	AFRICA = "africa",
	ASIA = "asia",
	EUROPE = "europe",
	NORTH_AMERICA = "northAmerica",
	OCEANIA = "oceania",
	SOUTH_AMERICA = "southAmerica",
	NATIONAL_CONTINENTS = "nationalContinents",
}

export interface CountryData {
	[Continent.AFRICA]?: ContinentData;
	[Continent.ASIA]?: ContinentData;
	[Continent.EUROPE]?: ContinentData;
	[Continent.NORTH_AMERICA]?: ContinentData;
	[Continent.OCEANIA]?: ContinentData;
	[Continent.SOUTH_AMERICA]?: ContinentData;
	[Continent.NATIONAL_CONTINENTS]?: ContinentData;
}

export type CountrySelection = {
	[continent in Continent]: string[];
};

export const emptySelection = {
	[Continent.AFRICA]: [],
	[Continent.ASIA]: [],
	[Continent.EUROPE]: [],
	[Continent.NORTH_AMERICA]: [],
	[Continent.SOUTH_AMERICA]: [],
	[Continent.OCEANIA]: [],
	[Continent.NATIONAL_CONTINENTS]: [],
};

export interface UserCountrySelection {
	countries: CountrySelection;
	count: number;
}

export const ContinentsPath = {
	[Continent.AFRICA]: africa,
	[Continent.ASIA]: asia,
	[Continent.EUROPE]: europe,
	[Continent.NORTH_AMERICA]: northAmerica,
	[Continent.SOUTH_AMERICA]: southAmerica,
	[Continent.OCEANIA]: oceania,
	[Continent.NATIONAL_CONTINENTS]: nationalContinents,
};
